//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server, quotationUrl } from "@/services/constants";
import AddProductDialog from "./AddProductDialog.vue";
import Swal from "sweetalert2";
import pdfQuotationGenerator from "@/utils/pdfQuotationGenerator";
import PdfPreviewDialog from "@/components/cards/PdfPreviewDialog";

export default {
    name: "QuotationForm",
    components: { AddProductDialog, PdfPreviewDialog },
    data() {
        return {
            pdfBlob: null,
            pdfObj: null,
            dialogPDF: false,
            currency_list: [],
            menuPoDate: false,
            menuDeliveryDate: false,
            dialogDelete: false,
            showAddProductDialog: false,
            addProductPrefill: "",
            addProductTarget: null, // { type, row }
            rowSeq: 100,
            ADD_NEW_PREFIX: '+ เพิ่ม "',
            ADD_NEW_SUFFIX: '" เป็นสินค้าใหม่',
            dragSrc: null,
            dragOver: null,

            snackbar: { show: false, text: "", color: "success" },

            docType: "fixed",

            doc: {
                client_id: 0,
                doc_no: "",
                status: "Draft",
                doc_date_show: this.getTodayShow(),
                client_code: "",
                client_name: "",
                client_address: "",
                invoice_address: "",
                tax_id: "",
                branch: "",
                payment_term: "0",
                currency: "THB",
                vat_percent: "0.00",
                attention: "",
                contact_position: "",
                po_no: "",
                po_date: "",
                delivery_date: "",
                additional_info: "",
                not_to_exceed_cap: "",
            },

            clientOptions: [],

            masterItems: [],

            fixedRows: [],
            estimateRows: [],
            uploadedFiles: [],
            removedFileIds: [],
            dialogSelectTitle: false,
            dialogSelectClientInfo: "1",
            print_header_list: [
                {
                    id: "1",
                    com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
                    com_eng_2: "ATTORNEYS AT LAW",
                    com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                    com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                    com_add_no: "942/69 RAMA IV ROAD,",
                    com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
                    com_add_country: "BANGKOK 10500, THAILAND",
                    com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
                    com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
                    com_add_email: "E-MAIL : account@dejudom.com",
                    com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
                    com_display_name: "Dej-Udom & Associates Ltd.",
                },
                {
                    id: "3",
                    com_eng_1: "DEJ-UDOM & ASSOCIATES",
                    com_eng_2: "ATTORNEYS AT LAW",
                    com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
                    com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                    com_add_no: "942/69 RAMA IV ROAD,",
                    com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
                    com_add_country: "BANGKOK 10500, THAILAND",
                    com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
                    com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
                    com_add_email: "E-MAIL : account@dejudom.com",
                    com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
                    com_display_name: "Dej-Udom & Associates",
                },
            ],
            suppressDocTypeWatch: false,
            showVatDetailDialog: false,
            vatDetailType: "fixed",
        };
    },
    computed: {
        // เข้าทาง /add-quotation (ไม่มี :id) = โหมดสร้างใหม่ เสมอเป็น Draft ไม่มีปุ่มเลือกสถานะ
        // เข้าทาง /edit-quotation/:id = โหลดสถานะจริงจากเอกสาร (Draft/Submitted/Invoiced/InProgress)
        isEditMode() {
            return !!this.$route.params.id;
        },
        statusLabel() {
            return { Draft: "Draft", Submitted: "Submitted", Invoiced: "Invoiced", InProgress: "In Progress" }[this.doc.status];
        },
        statusColor() {
            return { Draft: "grey", Submitted: "blue", Invoiced: "green", InProgress: "purple" }[this.doc.status];
        },
        isLocked() {
            return this.doc.status === "Submitted"
                || this.doc.status === "Invoiced"
                || this.doc.status === "InProgress";
        },
        headerEditable() {
            return !this.isLocked; // Draft และ Submitted แก้ header ได้
        },
        itemsEditable() {
            return this.doc.status === "Draft"; // แก้รายการได้เฉพาะ Draft
        },
        docTypeEditable() {
            return this.doc.status === "Draft"; // ล็อกทันทีหลัง Submit
        },
        showDelete() {
            // ยังไม่มีเอกสารให้ลบตอนสร้างใหม่ (add-quotation) — โชว์ปุ่ม Delete เฉพาะตอนแก้ไขเอกสารที่มีอยู่แล้ว
            if (!this.isEditMode) return false;
            return !this.isLocked; // ไม่แสดงปุ่มลบเลยเมื่อ Invoiced/InProgress (REQ-2)
        },
        fixedTotals() {
            let vatBase = 0, noVatBase = 0, vatAmount = 0, vatCount = 0, noVatCount = 0;
            const rate = Number(this.doc.vat_percent) || 0;
            this.fixedRows.forEach((r) => {
                const lineTotal = (Number(r.qty) || 0) * (Number(r.price) || 0);
                if (r.applyVat) {
                    vatCount += 1;
                    vatBase += lineTotal;
                    vatAmount += lineTotal * (rate / 100);
                } else {
                    noVatCount += 1;
                    noVatBase += lineTotal;
                }
            });
            const total = vatBase + noVatBase;
            return {
                total, vat: vatAmount, grandTotal: total + vatAmount,
                vatBase, noVatBase, vatCount, noVatCount, rowCount: this.fixedRows.length,
            };
        },
        estimateTotals() {
            let vatBase = 0, noVatBase = 0, vatAmount = 0, vatCount = 0, noVatCount = 0;
            const rate = Number(this.doc.vat_percent) || 0;
            this.estimateRows.forEach((r) => {
                const lineTotal = Number(r.rate) || 0;
                if (r.applyVat) {
                    vatCount += 1;
                    vatBase += lineTotal;
                    vatAmount += lineTotal * (rate / 100);
                } else {
                    noVatCount += 1;
                    noVatBase += lineTotal;
                }
            });
            const total = vatBase + noVatBase;
            return {
                total, vat: vatAmount, grandTotal: total + vatAmount,
                vatBase, noVatBase, vatCount, noVatCount, rowCount: this.estimateRows.length,
            };
        },
        vatDetailRows() {
            const rate = Number(this.doc.vat_percent) || 0;
            const rows = this.vatDetailType === "fixed" ? this.fixedRows : this.estimateRows;
            return rows.map((row) => {
                const base = this.vatDetailType === "fixed"
                    ? (Number(row.qty) || 0) * (Number(row.price) || 0)
                    : (Number(row.rate) || 0);
                const vatAmount = row.applyVat ? base * (rate / 100) : 0;
                return { name: row.name || "-", base, applyVat: row.applyVat, vatRate: rate, vatAmount, afterVat: base + vatAmount };
            });
        },
        vatDetailTotals() {
            return this.vatDetailType === "fixed" ? this.fixedTotals : this.estimateTotals;
        },
        allFixedVatSelected() {
            return this.fixedRows.length > 0 && this.fixedRows.every((r) => r.applyVat);
        },
        fixedVatIndeterminate() {
            const checkedCount = this.fixedRows.filter((r) => r.applyVat).length;
            return checkedCount > 0 && checkedCount < this.fixedRows.length;
        },
        allEstimateVatSelected() {
            return this.estimateRows.length > 0 && this.estimateRows.every((r) => r.applyVat);
        },
        estimateVatIndeterminate() {
            const checkedCount = this.estimateRows.filter((r) => r.applyVat).length;
            return checkedCount > 0 && checkedCount < this.estimateRows.length;
        },
    },
    watch: {
        // ตรวจจับตอน AddProductDialog ปิด ไม่ว่าจากปุ่ม "ยกเลิก" หรือ ESC/click outside
        showAddProductDialog(val) {
            if (!val && this.addProductTarget) {
                // ถ้า addProductTarget ยังไม่ถูกเคลียร์ = ปิดโดยไม่ได้กด "บันทึก"
                // (onProductSaved จะ set addProductTarget = null ไปแล้วก่อนหน้านี้ถ้ากด save)
                // ต้องล้าง searchText ของแถวที่ trigger dialog ด้วย ไม่งั้นข้อความเก่าจะค้างในกล่อง
                this.addProductTarget.row.searchText = "";
                this.addProductTarget = null;
            }
        },
        docType(newVal, oldVal) {
            if (this.suppressDocTypeWatch) return;
            if (newVal === oldVal) return;

            const hasFixedData = this.fixedRows.length > 0;
            const hasEstimateData = this.estimateRows.length > 0;

            if (hasFixedData || hasEstimateData) {
                const proceed = window.confirm(
                    "การสลับประเภทเอกสารจะล้างรายการที่กรอกไว้ทั้งหมด ต้องการดำเนินการต่อหรือไม่"
                );
                if (!proceed) {
                    // ยกเลิกการสลับ กลับไปค่าเดิม
                    this.suppressDocTypeWatch = true;
                    this.docType = oldVal;
                    this.$nextTick(() => {
                        this.suppressDocTypeWatch = false;
                    });
                    return;
                }
            }

            this.fixedRows = [];
            this.estimateRows = [];
            this.rowSeq = 100;
            this.doc.not_to_exceed_cap = "";
        },
        '$route.params.id': {
            immediate: false,
            handler(newId, oldId) {
                if (newId !== oldId) {
                    this.reloadPage();
                }
            }
        }
    },
    async mounted() {
        try {
            await api.checkVersion();

            this.userId = localStorage.getItem(server.USER_ID);
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

            if (this.authorize_id == null || this.authorize_id == 0) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Authorize Failed!!!",
                    "Please Logout And Login Again!!!",
                    "text-h5 red--text text-center"
                );
                this.$router.back();
                return;
            }

            const parser = document.createElement("a");
            parser.href = window.location;
            const routerPath = parser.pathname.split("/")[1];

            const resAuth = await api.getAuthorize(this.userId, routerPath);
            const permission = resAuth.data[0];

            if (!permission) {
                this.$router.back();
                return;
            }

            this.authorize_view = permission.smd_view >= 1;
            this.authorize_add = permission.smd_add >= 1;
            this.authorize_edit = permission.smd_edit >= 1;
            this.authorize_del = permission.smd_del >= 1;

            if (!this.authorize_view) {
                this.$router.back();
                return;
            }

            if (this.userId && api.isLoggedIn()) {
                // already logged in
            } else {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
                return;
            }
        } catch (error) {
            // ✅ catch นี้ครอบเฉพาะ auth flow เท่านั้น
            console.error("QuotationForm mounted() auth error:", error);
            this.$store.state.isLogged = false;
            this.$router.push("/login");
            return;
        }

        // ===== โหลดข้อมูลฟอร์ม แยก catch ออกจาก auth =====
        this.$showLoader();
        try {
            await this.loadCurrency();
            await this.loadCustomer();
            await this.loadMaterProductItem();
            if (this.isEditMode) {
                await this.loadQuotationForEdit(this.$route.params.id);
                await this.loadDataFile(this.$route.params.id)
            } else {
                this.doc.status = "Draft";
            }
        } catch (error) {
            // ✅ ไม่เกี่ยวกับ auth — แจ้ง error ตรงๆ ไม่เด้ง login
            console.error("QuotationForm mounted() load data error:", error);
            await Swal.fire({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: "ไม่สามารถโหลดข้อมูลฟอร์มได้ กรุณาลองใหม่อีกครั้ง",
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
            });
        } finally {
            this.$hideLoader();
        }
    },
    beforeDestroy() {
        // เคลียร์ object URL ทั้งหมดตอนออกจากหน้า กัน memory leak
        this.uploadedFiles.forEach((f) => URL.revokeObjectURL(f.url));
    },

    methods: {
        toggleAllVat(type, checked) {
            const rows = type === "fixed" ? this.fixedRows : this.estimateRows;
            rows.forEach((r) => { r.applyVat = checked; });
        },
        openVatDetail(type) {
            this.vatDetailType = type;
            this.showVatDetailDialog = true;
        },
        onPrint() {
            this.dialogSelectTitle = true;
        },
        getFileName() {
            return `Quotation_${this.doc.doc_no || ((this.docType === "fixed" ? "QT-" : "EST-") + "(ออกอัตโนมัติเมื่อบันทึก)")}.pdf`
        },
        async confirmPrint() {
            try {
                const selectedCompany =
                    this.print_header_list.find((c) => c.id === this.dialogSelectClientInfo) ||
                    this.print_header_list[0];

                const header = {
                    company_inv: "L",
                    com_eng_1: selectedCompany.com_eng_1,
                    com_eng_2: selectedCompany.com_eng_2,
                    com_thai: selectedCompany.com_thai,
                    com_add_name: selectedCompany.com_add_name,
                    com_add_no: selectedCompany.com_add_no,
                    com_add_city: selectedCompany.com_add_city,
                    com_add_country: selectedCompany.com_add_country,
                    com_add_tel: selectedCompany.com_add_tel,
                    com_add_email: selectedCompany.com_add_email,
                    com_add_tax_id: selectedCompany.com_add_tax_id,
                    company_display_name: selectedCompany.com_display_name,
                    doc_no: this.doc.doc_no,
                    doc_date: this.doc.doc_date,
                    doc_type: this.docType,
                    customer_name: this.doc.client_name,
                    customer_address: this.doc.client_address,
                    customer_taxid: this.doc.tax_id,
                    attention: this.doc.attention,
                    payment_term: this.doc.payment_term,
                    currency: this.doc.currency,
                    subtotal: this.docType === "fixed" ? this.fixedTotals.total : this.estimateTotals.total,
                    vat_percent: this.doc.vat_percent,
                    vat_base: this.docType === "fixed" ? this.fixedTotals.vatBase : this.estimateTotals.vatBase,
                    no_vat_base: this.docType === "fixed" ? this.fixedTotals.noVatBase : this.estimateTotals.noVatBase,
                    vat_amount: this.docType === "fixed" ? this.fixedTotals.vat : this.estimateTotals.vat,
                    grand_total: this.docType === "fixed" ? this.fixedTotals.grandTotal : this.estimateTotals.grandTotal,
                    amount_in_words: "",
                    not_to_exceed_cap: this.doc.not_to_exceed_cap,
                    additional_info: this.doc.additional_info,
                };

                const sourceRows = this.docType === "fixed" ? this.fixedRows : this.estimateRows;
                const items = sourceRows.map((row) => ({
                    description: row.name,
                    detail: row.detail,
                    apply_vat: !!row.applyVat,
                    amount: this.docType === "fixed" ? (row.qty || 0) * (row.price || 0) : undefined,
                    rate: this.docType === "estimate" ? this.fmt(row.rate) : undefined,
                }));

                //ฟังก์ชันปริ้นเก่า
                // await pdfQuotationGenerator.exportToPDF({ header, items });

                //ฟังก์ชันปริ้นใหม่
                const blob = await pdfQuotationGenerator.exportToPDF({ header, items });
                this.pdfBlob = blob;
                this.dialogSelectTitle = false;
                this.dialogPDF = true;
            } catch (error) {
                this.dialogSelectTitle = false;
                console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
                alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
            }
        },
        async reloadPage() {
            this.$showLoader();
            try {
                await this.loadCurrency();
                await this.loadCustomer();
                await this.loadMaterProductItem();
                if (this.isEditMode) {
                    await this.loadQuotationForEdit(this.$route.params.id);
                }
            } catch (error) {
                console.error("reloadPage error:", error);
                await Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
            } finally {
                this.$hideLoader();
            }
        },
        async loadCurrency() {
            const res_cur = await api.getDataCurrency();
            this.currency_list = res_cur.data;
        },
        async loadCustomer() {
            const result = await api.getAllCustomerListactiveCompany({
                params: {
                    company_id: localStorage.getItem(server.COMPANYID),
                },
            });

            this.clientOptions = result.data.map((item) => ({
                id: item.id,
                code: item.cust_account,
                name: item.name,
                address: item.address,
                tax_id: item.taxid,
                branch: item.branch,
                address_invoice: item.address_invoice,
                payment_term: item.payment_term,
                currency: item.currency,
                vat: item.vat,
                contact_position: item.contact_position,
                attention: item.contact_name,
            }));
        },
        async loadMaterProductItem() {
            const res = await api.billing_expense_getInvTitleByDep(localStorage.getItem(server.DEPARTMENT_ID));

            this.masterItems = res.data.map((item) => ({
                name: item.title,
                unit: item.unit,
                rate: Number(item.price),
            }));
        },
        async loadQuotationForEdit(id) {
            try {
                const res = await api.billing_expense_getAllQuotationsByID(id);
                const record = res.data;
                console.log(record)
                if (!record) {
                    await Swal.fire({
                        icon: "error",
                        title: "ไม่พบเอกสาร",
                        text: "ไม่พบเอกสารที่ต้องการแก้ไข",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                    this.$router.push("/quotation-list");
                    return;
                }

                this.doc = {
                    ...this.doc,
                    quotation_id: record.quotation_id,
                    doc_no: record.doc_no,
                    status: record.status,
                    doc_date_show: this.formatDocDateShow(record.doc_date),
                    client_id: record.client_id,
                    client_address: record.client_address,
                    payment_term: String(record.payment_term ?? "0"),
                    currency: record.currency,
                    vat_percent: String(record.vat_percent ?? "0"),
                    attention: record.attention,
                    contact_position: record.contact_position,
                    po_no: record.po_no,
                    po_date: record.po_date,
                    delivery_date: record.delivery_date,
                    additional_info: record.additional_info,
                    not_to_exceed_cap: record.not_to_exceed_cap != null ? String(record.not_to_exceed_cap) : "",
                };

                // ✅ ป้องกัน watcher docType เคลียร์ rows ที่กำลังจะ map เข้ามาด้านล่าง
                this.suppressDocTypeWatch = true;
                this.docType = record.doc_type; // "fixed" | "estimate"

                // ✅ เพิ่มกลับเข้ามา — ค้นหา client จาก clientOptions แล้วเติมค่าเข้าฟอร์ม
                const clientMatch = this.clientOptions.find(
                    (c) => Number(c.id) === Number(record.client_id)
                );

                if (clientMatch) {
                    this.doc.client_code = clientMatch.code;
                    this.doc.client_name = clientMatch.name;
                    this.doc.invoice_address = clientMatch.address_invoice;
                    this.doc.tax_id = clientMatch.tax_id;
                    this.doc.branch = clientMatch.branch;
                } else if (record.client) {
                    // fallback: ลูกค้าอาจถูกปิดใช้งาน ไม่อยู่ใน active list แต่ backend include client มาด้วย
                    this.doc.client_code = "";
                    this.doc.client_name = record.client.name || "";
                    console.warn(`Client id ${record.client_id} ไม่พบใน active client list`);
                }

                const items = record.items || [];
                if (this.docType === "fixed") {
                    this.fixedRows = items.map((item) => ({
                        id: item.item_row_id, name: item.item_name, searchText: "", detail: item.detail || "",
                        qty: item.qty != null ? Number(item.qty) : 0, unit: item.unit || "",
                        price: item.unit_price != null ? Number(item.unit_price) : 0,
                        applyVat: item.apply_vat != null ? !!item.apply_vat : true,
                    }));
                    this.estimateRows = [];
                } else {
                    this.estimateRows = items.map((item) => ({
                        id: item.item_row_id, name: item.item_name, searchText: "", detail: item.detail || "",
                        rate: item.line_total != null ? Number(item.line_total) : "",
                        applyVat: item.apply_vat != null ? !!item.apply_vat : true,
                    }));
                    this.fixedRows = [];
                }

                const maxId = Math.max(0, ...items.map((i) => i.item_row_id || 0));
                this.rowSeq = Math.max(this.rowSeq, maxId);

                // ✅ คืนค่า flag กลับหลัง map ข้อมูลเสร็จ ให้ watcher ทำงานปกติตอน user สลับ toggle ต่อไป
                this.$nextTick(() => {
                    this.suppressDocTypeWatch = false;
                });

            } catch (error) {
                console.error("loadQuotationForEdit error:", error);
                await Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: "ไม่สามารถโหลดข้อมูลเอกสารได้",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
                this.$router.push("/quotation-list");
            }
        },
        async loadDataFile(id) {
            try {
                const res = await api.billing_expense_load_file(id, Number(localStorage.getItem(server.COMPANYID)));
                const files = res.data || [];

                // ✅ Map ไฟล์ที่มีอยู่แล้วในระบบ (จาก backend) เข้า uploadedFiles
                // เพื่อให้แสดงผลใน file-list เหมือนไฟล์ที่เพิ่ง upload ใหม่
                this.uploadedFiles = files.map((f) => ({
                    id: `existing_${f.id}`,       // prefix กันชนกับไฟล์ใหม่ที่ใช้ Date.now()
                    fileId: f.id,                  // เก็บ id จริงจาก backend ไว้ใช้ตอนลบ/อ้างอิง
                    file: null,                    // ไฟล์นี้อยู่บน server แล้ว ไม่มี File object ดิบในเบราว์เซอร์
                    name: f.file_name,
                    url: `${server.API_URL}/billing-expense/quotations/file/${f.id}`, // ปรับตาม endpoint จริงที่ backend ใช้เสิร์ฟไฟล์
                    isExisting: true,              // flag บอกว่าเป็นไฟล์เดิม ไม่ใช่ไฟล์ใหม่ที่รอ upload
                }));
            } catch (error) {
                console.error("loadFile error:", error);
            }
        },
        getTodayShow() {
            const now = new Date();
            const bkkTime = new Date(now.getTime() + 7 * 60 * 60 * 1000);
            const dd = String(bkkTime.getUTCDate()).padStart(2, "0");
            const mm = String(bkkTime.getUTCMonth() + 1).padStart(2, "0");
            const yyyy = bkkTime.getUTCFullYear();
            return `${dd}/${mm}/${yyyy}`;
        },
        formatDateShow(isoDate) {
            if (!isoDate) return "";
            const d = new Date(isoDate);
            if (isNaN(d.getTime())) return "";
            const dd = String(d.getDate()).padStart(2, "0");
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const yyyy = d.getFullYear();
            return `${dd}/${mm}/${yyyy}`;
        },
        onFileSelected(e) {
            const files = Array.from(e.target.files || []);
            const rejected = [];

            files.forEach((file) => {
                // อนุญาตเฉพาะไฟล์ PDF เท่านั้น เช็คทั้ง MIME type และนามสกุลไฟล์ (กันเคส MIME type ไม่ถูกต้องจากบาง OS)
                const isPdf = file.type === "application/pdf" || /\.pdf$/i.test(file.name);
                if (!isPdf) {
                    rejected.push(file.name);
                    return;
                }

                const sanitizedName = this.sanitizeFileName(file.name);
                const uniqueName = this.getUniqueFileName(sanitizedName);

                // ✅ สร้าง File object ใหม่ด้วยชื่อที่ unique แล้ว แทนที่จะใช้ file เดิม
                // เพื่อให้ไฟล์จริงที่จะส่งไป backend มีชื่อตรงกับที่แสดงบน UI (กันชื่อไฟล์ชนกันจริงๆ ตอนอัพโหลด)
                const renamedFile = new File([file], uniqueName, {
                    type: file.type,
                    lastModified: file.lastModified,
                });

                const url = URL.createObjectURL(renamedFile);
                this.uploadedFiles.push({
                    id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
                    file: renamedFile, // ✅ เก็บไฟล์ที่ถูกเปลี่ยนชื่อแล้วจริงๆ
                    name: uniqueName,
                    url,
                });
            });

            if (rejected.length > 0) {
                Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: `รองรับเฉพาะไฟล์ PDF เท่านั้น: ${rejected.join(", ")}`,
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
            }

            e.target.value = "";
        },
        sanitizeFileName(originalName) {
            const dotIdx = originalName.lastIndexOf(".");
            const base = dotIdx > -1 ? originalName.slice(0, dotIdx) : originalName;
            const ext = dotIdx > -1 ? originalName.slice(dotIdx) : "";

            const sanitizedBase = base
                .replace(/[^a-zA-Z0-9ก-๙._-]+/g, "_")   // แทนที่ space/อักขระพิเศษด้วย _
                .replace(/_+/g, "_")                      // ยุบ _ ติดกันหลายตัวให้เหลือตัวเดียว
                .replace(/^_+|_+$/g, "");                 // ตัด _ นำหน้า/ท้ายทิ้ง

            return `${sanitizedBase || "file"}${ext.toLowerCase()}`; // กันเคสชื่อว่างเปล่าหลัง sanitize
        },

        getUniqueFileName(originalName) {
            const existingNames = new Set(this.uploadedFiles.map((f) => f.name));
            if (!existingNames.has(originalName)) return originalName;

            const dotIdx = originalName.lastIndexOf(".");
            const base = dotIdx > -1 ? originalName.slice(0, dotIdx) : originalName;
            const ext = dotIdx > -1 ? originalName.slice(dotIdx) : "";

            let counter = 1;
            let candidate = `${base}_${counter}${ext}`;
            while (existingNames.has(candidate)) {
                counter += 1;
                candidate = `${base}_${counter}${ext}`;
            }
            return candidate;
        },

        // เปิดไฟล์ preview ในแท็บใหม่
        previewFile(f) {
            let fileUrl = f.url;

            // ถ้าเป็นไฟล์เดิมที่โหลดจาก server ใช้ pattern URL ตามที่กำหนด
            if (f.isExisting) {
                fileUrl = `${quotationUrl}/${this.$route.params.id}/${f.name}`;
            }

            const previewWindow = window.open("", "_blank");

            if (!previewWindow) {
                Swal.fire({
                    icon: "warning",
                    title: "แจ้งเตือน",
                    text: "เบราว์เซอร์บล็อก popup กรุณาอนุญาตเปิดแท็บใหม่",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
                return;
            }

            // เขียน HTML เข้าไปในแท็บใหม่โดยตรง — address bar จะแสดงแค่ about:blank ไม่โชว์ URL ไฟล์จริง
            previewWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>${f.name}</title>
            <style>
                * { margin: 0; padding: 0; box-sizing: border-box; }
                body { height: 100vh; display: flex; flex-direction: column; font-family: sans-serif; }
                .toolbar {
                    padding: 8px 16px;
                    background: #fafafa;
                    border-bottom: 1px solid #e0e0e0;
                    display: flex;
                    align-items: center;
                }
                .toolbar button {
                    padding: 6px 16px;
                    border: 1px solid #90a4ae;
                    background: #fff;
                    border-radius: 4px;
                    cursor: pointer;
                    font-size: 14px;
                }
                .toolbar button:hover { background: #f0f0f0; }
                .frame-wrap { flex: 1; }
                iframe { width: 100%; height: 100%; border: none; }
            </style>
        </head>
        <body>
            <div class="toolbar">
                <button onclick="window.close()">← Back</button>
            </div>
            <div class="frame-wrap">
                <iframe src="${fileUrl}"></iframe>
            </div>
        </body>
        </html>
    `);
            previewWindow.document.close();
        },

        removeFile(id) {
            const idx = this.uploadedFiles.findIndex((f) => f.id === id);
            if (idx === -1) return;

            const target = this.uploadedFiles[idx];

            if (target.isExisting) {
                this.removedFileIds.push({
                    module_name: "Quotation",
                    module_id: this.$route.params.id,
                    file_id: target.fileId,
                    filename: target.name,
                });
            } else {
                URL.revokeObjectURL(target.url);
            }

            this.uploadedFiles.splice(idx, 1);
        },
        getBackList() {
            this.$router.push("/quotation-list");
        },
        fmt(n) {
            return (Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        onClientSelect(value, key = "code") {
            const c =
                key === "code"
                    ? this.clientOptions.find((x) => x.code === value)
                    : this.clientOptions.find((x) => x.name === value);

            if (c) {
                this.doc.client_id = c.id
                this.doc.client_code = c.code;
                this.doc.client_name = c.name;
                this.doc.client_address = c.address;
                this.doc.invoice_address = c.address_invoice;
                this.doc.tax_id = c.tax_id;
                this.doc.branch = c.branch;
                this.doc.payment_term = c.payment_term;
                this.doc.currency = c.currency; // ← เพิ่มเงื่อนไข fallback
                this.doc.vat_percent = c.vat;
                this.doc.contact_position = c.contact_position;
                this.doc.attention = c.attention;
            } else {
                this.doc.client_code = "";
                this.doc.client_name = "";
                this.doc.client_address = "";
                this.doc.invoice_address = "";
                this.doc.tax_id = "";
                this.doc.branch = "";
                this.doc.payment_term = "0";
                this.doc.currency = "THB";

                this.doc.vat_percent = "";
                this.doc.contact_position = "";
                this.doc.attention = "";
            }
        },

        filterMaster(text) {
            const t = (text || "").toString().trim().toLowerCase();
            const original = (text || "").toString().trim();
            if (!t) return this.masterItems.map((m) => m.name);
            const matches = this.masterItems.filter((m) => m.name.toLowerCase().includes(t)).map((m) => m.name);
            if (matches.length === 0 && original) {
                return [`${this.ADD_NEW_PREFIX}${original}${this.ADD_NEW_SUFFIX}`];
            }
            return matches;
        },
        // เช็คว่า item ที่ render อยู่ใน dropdown เป็นตัวเลือก "+ เพิ่มสินค้าใหม่" หรือเปล่า (ใช้แต่งสีฟ้า)
        isAddNewItem(item) {
            return (
                typeof item === "string" &&
                item.startsWith(this.ADD_NEW_PREFIX) &&
                item.endsWith(this.ADD_NEW_SUFFIX)
            );
        },
        onNameInput(type, row, val) {
            if (
                typeof val === "string" &&
                val.startsWith(this.ADD_NEW_PREFIX) &&
                val.endsWith(this.ADD_NEW_SUFFIX)
            ) {
                const typed = val.slice(this.ADD_NEW_PREFIX.length, val.length - this.ADD_NEW_SUFFIX.length);
                row.name = "";
                this.openAddProduct(type, row, typed);
                return;
            }
            row.name = val;
            const found = this.masterItems.find((m) => m.name === val);
            if (found) {
                if (type === "fixed") {
                    row.unit = found.unit;
                    row.price = found.rate;   // <-- เพิ่ม: auto-fill ราคาต่อหน่วย
                } else {
                    row.rate = found.rate;    // <-- เพิ่ม: auto-fill ราคาสำหรับ estimate
                }
            }
        },
        // Note 21: กด Enter เฉยๆ ย้าย focus ไปแถวถัดไป (หรือเพิ่มแถวใหม่ถ้าเป็นแถวสุดท้าย)
        // กด Shift+Enter ขึ้นบรรทัดใหม่ในช่องรายละเอียดตามปกติ
        onDetailKeydown(e, type, row) {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                const arr = type === "fixed" ? this.fixedRows : this.estimateRows;
                const idx = arr.findIndex((r) => r.id === row.id);
                const next = arr[idx + 1];
                if (next) {
                    this.$nextTick(() => {
                        const el = document.querySelector(`tr[data-row-id="${type}-${next.id}"] .item-picker input`);
                        if (el) el.focus();
                    });
                } else {
                    this.addRow(type);
                }
            }
        },
        addRow(type) {
            this.rowSeq += 1;
            if (type === "fixed") {
                this.fixedRows.push({ id: this.rowSeq, name: "", searchText: "", detail: "", qty: 1, unit: "", price: 0, applyVat: true });
            } else {
                this.estimateRows.push({ id: this.rowSeq, name: "", searchText: "", detail: "", rate: "", applyVat: true });
            }
        },
        delRow(type, id) {
            if (type === "fixed") this.fixedRows = this.fixedRows.filter((r) => r.id !== id);
            else this.estimateRows = this.estimateRows.filter((r) => r.id !== id);
        },
        // ---- Add Product modal ----
        openAddProduct(type, row, prefill) {
            this.addProductTarget = { type, row };
            this.addProductPrefill = prefill || "";
            this.showAddProductDialog = true;
        },
        async onProductSaved(product) {
            // เติมค่าลงแถวที่ trigger dialog ทันที ไม่ต้องรอ API โหลด masterItems ใหม่
            // กันปัญหา field ว่างค้างระหว่างรอ network (dialog ปิดไปแล้วตั้งแต่ก่อน onProductSaved ทำงานเสร็จ)
            if (this.addProductTarget) {
                const { type, row } = this.addProductTarget;
                row.name = product.name;
                row.searchText = product.name; // sync search text ให้ตรงกับชื่อที่เพิ่งเลือก ไม่ให้ค้างข้อความเก่า
                if (type === "fixed") {
                    row.unit = product.unit;
                    row.price = product.rate;
                } else {
                    row.rate = product.rate;
                }
            }
            this.addProductTarget = null;

            // โหลด masterItems ใหม่แบบ background เพื่อให้ dropdown ครั้งถัดไปมีตัวเลือกล่าสุดจาก backend
            // ไม่ต้อง await ก่อนแสดงผลแถว เพราะแถวถูกเติมค่าไปแล้วด้านบน
            try {
                await this.loadMaterProductItem();
            } catch (error) {
                console.error("loadMaterProductItem error:", error);
            }
        },
        // ---- Drag & drop reorder ----
        onDragStart(type, id) {
            this.dragSrc = { type, id };
        },
        onDragOver(type, id) {
            if (!this.dragSrc || this.dragSrc.type !== type) return;
            this.dragOver = id;
        },
        onDrop(type, id) {
            if (!this.dragSrc || this.dragSrc.type !== type || this.dragSrc.id === id) return;
            const arr = type === "fixed" ? this.fixedRows : this.estimateRows;
            const fromIdx = arr.findIndex((r) => r.id === this.dragSrc.id);
            const toIdx = arr.findIndex((r) => r.id === id);
            const [moved] = arr.splice(fromIdx, 1);
            arr.splice(toIdx, 0, moved);
            this.dragSrc = null;
            this.dragOver = null;
        },
        onDragEnd() {
            this.dragSrc = null;
            this.dragOver = null;
        },
        dragRowClass(type, id) {
            return this.dragOver === id && this.dragSrc && this.dragSrc.type === type ? "drop-target" : "";
        },
        // ---- Validation / Save / Submit / Delete ----
        validateBeforeSubmit() {
            if (!this.doc.client_code) {
                Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: "กรุณาเลือก Client ก่อน Submit",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
                return false;
            }
            const rows = this.docType === "fixed" ? this.fixedRows : this.estimateRows;
            if (rows.length === 0) {
                Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: "กรุณาเพิ่มรายการอย่างน้อย 1 รายการ",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
                return false;
            }
            return true;
        },
        // แปลง "" / undefined / null เป็น null สำหรับ field ตัวเลข กัน "invalid input syntax for type numeric"
        toNullableNumber(val) {
            if (val === "" || val === undefined || val === null) return null;
            const n = Number(val);
            return isNaN(n) ? null : n;
        },

        // แปลงวันที่ว่างเปล่า/parse ไม่ได้ เป็น null กัน "invalid input syntax for type date"
        toNullableDate(val) {
            if (!val || val === "" || val === "Invalid date") return null;
            const d = new Date(val);
            if (isNaN(d.getTime())) return null;
            return val; // v-date-picker คืนเป็น "YYYY-MM-DD" อยู่แล้ว ส่งตรงได้ถ้า valid
        },

        // แปลง "" / undefined เป็น null สำหรับ field ข้อความที่เป็น optional (nullable ใน DB)
        toNullableString(val) {
            return val === "" || val === undefined ? null : val;
        },

        // ปัดเศษทศนิยม 2 ตำแหน่งตามหลักคณิตศาสตร์ (round half up) กัน floating point error
        round2(num) {
            const n = Number(num) || 0;
            return Math.round((n + Number.EPSILON) * 100) / 100;
        },
        getTodayDateOnly() {
            const now = new Date();
            const bkkTime = new Date(now.getTime() + 7 * 60 * 60 * 1000);
            const yyyy = bkkTime.getUTCFullYear();
            const mm = String(bkkTime.getUTCMonth() + 1).padStart(2, "0");
            const dd = String(bkkTime.getUTCDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
        },
        formatDocDateShow(dateOnly) {
            if (!dateOnly) return "";
            const [yyyy, mm, dd] = dateOnly.split("-");
            if (!yyyy || !mm || !dd) return "";
            return `${dd}/${mm}/${yyyy}`;
        },

        async onSaveDraft() {
            if (!this.validateBeforeSubmit()) return;

            await this.saveQuotation('Draft');
        },


        async onSubmit() {
            // ✅ ต้องเช็คก่อนเสมอ ห้ามแก้ตารางแล้วข้อมูลไม่ครบหลุดเข้าไปเป็น Submitted
            if (!this.validateBeforeSubmit()) return;

            if (this.docType === "fixed" && this.fixedTotals.grandTotal === 0) {
                // Edge case: Grand Total = 0 — ต้องให้ผู้ใช้ยืนยันก่อน เพราะหลัง Submit แก้ไขรายการไม่ได้แล้ว
                if (!window.confirm("ยอดรวมเป็น 0 ต้องการดำเนินการต่อหรือไม่")) return;
            }

            await this.saveQuotation('Submitted');
        },

        async saveQuotation(status) {
            var dataItem = {
                doc_type: this.docType,
                status: status, // ✅ ส่วนต่างเดียวระหว่าง Draft กับ Submit
                client_id: Number(this.doc.client_id),
                client_address: this.doc.client_address,
                payment_term: this.doc.payment_term,
                currency: this.doc.currency,
                vat_percent: Number(this.doc.vat_percent),
                attention: this.doc.attention,
                contact_position: this.doc.contact_position,
                po_no: this.doc.po_no,
                po_date: this.toNullableDate(this.doc.po_date),
                delivery_date: this.toNullableDate(this.doc.delivery_date),
                additional_info: this.doc.additional_info,
                subtotal: 0,
                vat_amount: 0,
                grand_total: 0,
                not_to_exceed_cap: 0,
                user_update: Number(localStorage.getItem(server.USER_ID)),
                company_id: Number(localStorage.getItem(server.COMPANYID)),
                department_id: Number(localStorage.getItem(server.DEPARTMENT_ID)),
            };

            if (this.docType == "fixed") {
                dataItem.subtotal = this.round2(this.fixedTotals.total);
                dataItem.vat_amount = this.round2(this.fixedTotals.vat);
                dataItem.grand_total = this.round2(this.fixedTotals.grandTotal);
            } else if (this.docType == "estimate") {
                dataItem.subtotal = this.round2(this.estimateTotals.total);
                dataItem.vat_amount = this.round2(this.estimateTotals.vat);
                dataItem.grand_total = this.round2(this.estimateTotals.grandTotal);
                dataItem.not_to_exceed_cap = Number(this.doc.not_to_exceed_cap);
            } else {
                return;
            }

            const sourceRows = this.docType === "fixed" ? this.fixedRows : this.estimateRows;
            const buildItemsPayload = (quotationId) =>
                sourceRows.map((row, idx) => {
                    const base = {
                        quotation_id: quotationId,
                        seq_no: idx + 1,
                        item_name: row.name || "",
                        detail: this.toNullableString(row.detail),
                        apply_vat: !!row.applyVat,                              // ✅ ใหม่
                        vat_rate: row.applyVat ? Number(this.doc.vat_percent) : null,
                    };
                    if (this.docType === "fixed") {
                        const qty = this.toNullableNumber(row.qty);
                        const unitPrice = this.toNullableNumber(row.price);
                        return {
                            ...base,
                            qty, unit: this.toNullableString(row.unit), unit_price: unitPrice,
                            line_total: this.round2((qty || 0) * (unitPrice || 0)),
                        };
                    } else {
                        return {
                            ...base,
                            qty: null, unit: null, unit_price: null,
                            line_total: this.toNullableNumber(row.rate),
                        };
                    }
                });

            const isEdit = !!this.$route.params.id;
            const successTitle = status === 'Draft'
                ? (isEdit ? "บันทึกสำเร็จ" : "เพิ่มสำเร็จ")
                : "Submit สำเร็จ";
            const successText = status === 'Draft'
                ? (isEdit ? "บันทึกการแก้ไข Draft เรียบร้อยแล้ว" : "เพิ่มใบเสนอราคาเรียบร้อยแล้ว")
                : "ส่งเอกสารเรียบร้อยแล้ว รายการถูกล็อกแล้ว";

            this.$showLoader(); // ✅ เริ่มโหลดก่อนยิง API

            // ===== โหมดแก้ไข (Edit) =====
            if (isEdit) {
                const editId = this.$route.params.id;

                try {

                    if (!this.doc.doc_no || this.doc.doc_no.trim() == "") {
                        dataItem.modeUpdate = "updateStatus";
                    } else {
                        dataItem.modeUpdate = "updateData";
                    }

                    const res_update = await api.billing_expense_updateQuotations(editId, dataItem);

                    if (res_update.status == 200) {
                        const itemsPayload = buildItemsPayload(Number(editId));

                        try {
                            await api.billing_expense_deleteQuotationsItem(editId);
                            if (itemsPayload.length > 0) {
                                await api.billing_expense_addQuotationsItem(itemsPayload);
                            }

                            // ✅ ลบไฟล์เดิมที่ผู้ใช้กด remove ไว้ (ยิงตอนนี้ก่อน Save จริง)
                            for (const removed of this.removedFileIds) {
                                await api.billing_expense_delete_file(removed); // removed = { module_name, module_id, file_id, filename }
                            }
                            this.removedFileIds = [];

                            // ✅ อัพโหลดเฉพาะไฟล์ใหม่ที่ยังไม่มี isExisting (ไฟล์เดิมไม่ต้อง upload ซ้ำ)
                            const newFiles = this.uploadedFiles.filter((f) => !f.isExisting);
                            for (const item of newFiles) {
                                let formData = new FormData();
                                formData.append("file", item.file);
                                formData.append("id", Number(this.$route.params.id));
                                formData.append("user_id", Number(localStorage.getItem(server.USER_ID)));
                                formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));

                                await api.billing_expense_upload_file(formData);
                            }

                            await this.loadQuotationForEdit(editId);
                            await this.loadDataFile(editId);
                            this.$hideLoader();

                            await Swal.fire({
                                icon: "success",
                                title: successTitle,
                                text: successText,
                                showConfirmButton: false,
                                timer: 2000,
                                timerProgressBar: true,
                            });

                        } catch (errorItems) {
                            console.error("update items error:", errorItems);
                            this.$hideLoader();
                            await Swal.fire({
                                icon: "error",
                                title: "เกิดข้อผิดพลาด",
                                text: "บันทึก Header สำเร็จ แต่บันทึกรายการล้มเหลว กรุณาลองใหม่อีกครั้ง",
                                showConfirmButton: false,
                                timer: 2500,
                                timerProgressBar: true,
                            });
                        }
                    }
                } catch (error) {
                    console.error("updateQuotations error:", error);
                    this.$hideLoader();
                    await Swal.fire({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: error.response?.data?.message || "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                }

            } else {
                // ===== โหมดสร้างใหม่ (Create) — ใช้ได้กับปุ่ม Save Draft เท่านั้น เพราะปุ่ม Submit ไม่โชว์ตอนสร้างใหม่ (v-if="isEditMode") =====
                dataItem.doc_date = this.getTodayDateOnly();
                dataItem.doc_no = this.toNullableString(this.doc.doc_no);
                dataItem.user_create = Number(localStorage.getItem(server.USER_ID));

                try {
                    const res_add = await api.billing_expense_addQuotations(dataItem);

                    if (res_add.status == 201) {
                        var main_id = Number(res_add.data.quotation_id);
                        const itemsPayload = buildItemsPayload(main_id);

                        try {
                            for (const item of this.uploadedFiles) {
                                let formData = new FormData();
                                formData.append("file", item.file); // item.file คือ File object ดิบที่เก็บไว้ตอน onFileSelected
                                formData.append("id", Number(main_id));
                                formData.append("user_id", Number(localStorage.getItem(server.USER_ID)));
                                formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));

                                await api.billing_expense_upload_file(formData);
                            }

                            const res_items = await api.billing_expense_addQuotationsItem(itemsPayload);

                            if (res_items.status == 201) {
                                this.uploadedFiles = []
                                await this.loadDataFile(Number(main_id));
                                this.$hideLoader();
                                await Swal.fire({
                                    icon: "success",
                                    title: successTitle,
                                    text: successText,
                                    showConfirmButton: false,
                                    timer: 2000,
                                    timerProgressBar: true,
                                });
                                this.$router.push(`/edit-quotation/${main_id}`);
                            }
                        } catch (errorItems) {
                            console.error("addQuotationsItem error:", errorItems);
                            this.$hideLoader();
                            await Swal.fire({
                                icon: "error",
                                title: "เกิดข้อผิดพลาด",
                                text: `บันทึก Header สำเร็จ (เลขที่ ${res_add.data.doc_no}) แต่บันทึกรายการล้มเหลว กรุณาแก้ไขเอกสารนี้อีกครั้ง`,
                                showConfirmButton: false,
                                timer: 3000,
                                timerProgressBar: true,
                            });
                            this.$router.push(`/edit-quotation/${main_id}`);
                        }
                    }
                } catch (error) {
                    console.error("addQuotations error:", error);
                    this.$hideLoader();
                    await Swal.fire({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: error.response?.data?.message || "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                }
            }
        },
        async confirmDelete() {
            const id = this.$route.params.id;
            this.dialogDelete = false; // ปิด dialog ยืนยันก่อน แล้วค่อยแสดง loader
            this.$showLoader();

            try {
                const res = await api.billing_expense_updateQuotations(id, { is_deleted: true, modeUpdate: "deleteData" });

                if (res.status == 200) {
                    this.$hideLoader();
                    await Swal.fire({
                        icon: "success",
                        title: "ลบสำเร็จ",
                        text: "ลบใบเสนอราคาเรียบร้อยแล้ว",
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true,
                    });
                    this.$router.push("/quotation-list");
                }
            } catch (error) {
                console.error("confirmDelete error:", error);
                this.$hideLoader();
                await Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: error.response?.data?.message || "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
            }
        },
    },
    async beforeCreate() {
        this.$store.state.navMenu = true;
    },

};
